<h2 *ngIf="expanded" class="header ml-2"
    data-automation-id="kids-catalog-header" translate>refineResults</h2>
<span *ngIf="expanded" class="divider-vertical" data-automation-id="kids-catalog-divider"></span>
<div class="kids-catalog-toggle" data-automation-id="kids-catalog-toggle">
  <span class="kids-catalog-slide-label right" translate>adultView</span>
  <div class="toggle-button" [class.toggle-button-nlb]="isNlbCustomer">
    <input data-automation-id="kids-catalog-toggle-input" type="checkbox" id="toggle" [checked]="!expanded" (change)="expandToggle(!expanded)" />
    <label for="toggle">
      <span translate class="sr-only">toggleCheckbox</span>
    </label>
  </div>
  <span class="kids-catalog-slide-label left" translate>kidsView</span>
</div>
<button
  *ngIf="fullscreen"
  data-automation-id="filter-panel-close-button"
  class="close-button ins-buttons button-secondary"
  aria-label="Close"
  (click)="closePanel()">
  <span aria-hidden="true" class="icon-close"></span>
</button>
